/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import * as amplitude from '@amplitude/analytics-browser';

export const START_SIGN_UP = () => amplitude.track('Start Sign up');
export const RESEND_EMAIL = () => amplitude.track('Resend Email');
export const VERIFY_EMAIL = () => amplitude.track('Sign up Verified');
export const FILL_PROFILE = () => amplitude.track('Fill Profile');
